var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportNoteSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_33894",
    "data-name": "Group 33894",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.792,
    height: 43.792,
    viewBox: "0 0 43.792 43.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_143171",
    "data-name": "Path 143171",
    d: "M43.417.376A1.282,1.282,0,0,0,42.033.092L.807,16.582a1.283,1.283,0,0,0-.083,2.346L16.98,26.812l7.885,16.257a1.283,1.283,0,0,0,1.154.723h.046a1.283,1.283,0,0,0,1.146-.806L43.7,1.76A1.283,1.283,0,0,0,43.417.376Z",
    transform: "translate(0 0)",
    fill: "#54d4f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143172",
    "data-name": "Path 143172",
    d: "M224.959,4.4,198.522,30.831l7.885,16.257a1.283,1.283,0,0,0,1.154.723h.046A1.283,1.283,0,0,0,208.752,47L225.243,5.779a1.283,1.283,0,0,0-.284-1.384Z",
    transform: "translate(-181.542 -4.019)",
    fill: "#14b7dd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportNoteSendIcon);
export default __webpack_public_path__ + "static/media/supportNoteSendIcon.c3d70d9839893be570168ca6c039b3d6.svg";
export { ForwardRef as ReactComponent };